import { createAction } from '@reduxjs/toolkit';

export const cleanAuth = createAction('auth/clean');
